import { Checkbox } from '@/components/ui/checkbox';
import { OrganizationOfferSectionProps } from './types';

const offerAgreementUrl = 'https://white-line.pro/dogovor-oferta/';
const tariffsUrl =
  'https://white-line.pro/wp-content/uploads/2026/10/prejskurant_na_uslugi_po_kompleksnoj_obrabotke_i_dostavke_tovarov2.pdf';

const OrganizationOfferSection = (props: OrganizationOfferSectionProps) => {
  const {
    isAccepted,
    onAcceptedChange,
    submitAttempted
  } = props;

  const shouldShowError = submitAttempted && !isAccepted;

  return (
    <section
      className="flex flex-col gap-3"
      id="offer-section"
    >
      <p className="text-sm font-semibold leading-5 text-foreground">
        Условия сотрудничества
      </p>

      <div className="flex flex-col gap-1">
        <label className="flex min-h-[44px] cursor-pointer items-start gap-2">
          <Checkbox
            checked={isAccepted}
            className="mt-0.5 size-5 shrink-0 rounded border-border-strong data-[state=checked]:border-accent data-[state=checked]:bg-accent data-[state=checked]:text-on-accent"
            onCheckedChange={(checked) => onAcceptedChange(checked === true)}
          />
          <span className="text-sm leading-5 text-muted-foreground">
            Я ознакомился(-ась) и принимаю условия договора оферты и тарифы на оказание услуг.
          </span>
        </label>

        <div className="flex flex-wrap items-center gap-x-6 pl-7">
          <a
            className="inline-flex min-h-[44px] items-center text-sm leading-5 text-accent hover:underline"
            href={offerAgreementUrl}
            rel="noreferrer"
            target="_blank"
          >
            Договор оферты
          </a>
          <a
            className="inline-flex min-h-[44px] items-center text-sm leading-5 text-accent hover:underline"
            href={tariffsUrl}
            rel="noreferrer"
            target="_blank"
          >
            Тарифы
          </a>
        </div>

        {shouldShowError ? (
          <p className="px-3 text-xs text-[hsl(var(--error-text))]">
            Подтвердите согласие с условиями, чтобы продолжить
          </p>
        ) : null}
      </div>
    </section>
  );
};

export default OrganizationOfferSection;